"use client"

import { useContextEnrichmentPlugin } from "@/app/infra/amplitude"

const AMPLITUDE_CONTEXT = {
  page: "Collection Leaderboard",
}

export function LeaderboardAnalyticsEnrichment() {
  useContextEnrichmentPlugin(
    "CollectionLeaderboardPageScopeProvider",
    AMPLITUDE_CONTEXT,
  )

  return null
}
